// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import BaseModel from '@glittr/frontend-core/src/plugins/servicelayer/serviceTypes/baseModel';
import ShopArticleTaxHistoryResourceViewModel from '../../../../viewModel/resource/ShopArticleTaxHistoryResourceViewModel';
import ResourceLinkViewModel from '../../../../viewModel/resource/ResourceLinkViewModel';
import ShopArticleTaxHistoryResourceListResultViewModel from '../../../../viewModel/resource/ShopArticleTaxHistoryResourceListResultViewModel';
import ShopArticleTaxHistoryResourceListResultDTO from '../../dto/resource/ShopArticleTaxHistoryResourceListResultDTO';

export default abstract class ShopArticleTaxHistoryResourceListResultModel extends BaseModel<ShopArticleTaxHistoryResourceListResultDTO> {
  /**
  */
  get items() { return this.getArrayModels(() => this.dto.items, ShopArticleTaxHistoryResourceViewModel)!; }
  set items(value) { this.setArrayModels(() => this.dto.items, value); }
  /**
  */
  get links() { return this.getArrayModels(() => this.dto.links, ResourceLinkViewModel)!; }
  set links(value) { this.setArrayModels(() => this.dto.links, value); }

  protected transformFromQuery(queries: Record<string, string>): void {
    const qs = {} as Record<string, string>;
    Object.keys(queries).forEach((key) => { qs[key.toLowerCase()] = queries[key]; });
    let value: any;
  }
}
